import { z } from "zod";

export const WorkspaceSchema = z.object({
	id: z.string(),
	name: z.string().default(""),
	host: z.string().default(""),
	slug: z.string().default(""),
	owner: z.boolean().default(false),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;

export const LOCAL_WORKSPACE_NAME = "local";
